import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import authService from "services/authService";
import LoginPage from "views/loginScreen/LoginPage";
import UpdateProfile from "views/tagadmin/UpdateProfile";
import UnAuthorized from "views/tagadmin/UnAuthorized";
import AccountCreated from "views/tagadmin/AccountCreated";
import ForgotPassword from "views/loginScreen/ForgotPassword";
import CreatePassword from "views/loginScreen/CreatePassword";
import AppBar from "layout/appbar/AppBar";
import LockedAccount from "./views/loginScreen/LockedAccount";

import "./styles/App.scss";

const ProtectedRoute = ({ children }) => {
  authService
    .refreshToken()
    .then((res) => {
      localStorage.setItem("token", res.data.access);
    })
    .catch(() => {});
  return children;
};
export default function App() {
  useEffect(() => {
    const interval = setInterval(() => {
      authService
        .refreshToken()
        .then((res) => {
          localStorage.setItem("token", res.data.access);
        })
        .catch(() => {});
    }, 30000);

    return () => clearInterval(interval);
  }, []);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/organization"
          element={
            <ProtectedRoute>
              <AppBar />
            </ProtectedRoute>
          }
        />
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/unAuthorized" element={<UnAuthorized />} />
        <Route path="/accountCreated" element={<AccountCreated />} />
        <Route path="/accountCreated" element={<AccountCreated />} />
        <Route path="/forgotpassword" element={<ForgotPassword />} />
        <Route path="/lockedaccount" element={<LockedAccount />} />
        <Route path="/reset-user-password" element={<CreatePassword />} />
      </Routes>
    </Router>
  );
}
